export default __webpack_public_path__ + "static/media/csv.7b446690.png";